export default __webpack_public_path__ + "static/media/270.43143d03.jpg";